import React from 'react'
import { useTranslation } from 'react-i18next'
import "./reconcileConfront.scss"

function ReconcileConfront() {

  const {t} =  useTranslation()

  return (
    <div className='container-reconcile-confront'>
      <div className="texts-reconcile-confront">
        <h1>{t("datasources.reconcile.title")}</h1>
        <p>{t("datasources.reconcile.section_text")}</p>
      </div>
    </div>
  )
}

export default ReconcileConfront